import ShowDetails from './components/show-details';
import styles from "./components/show-details.module.scss";
function App() {
  return (
    <div className={styles.containerApp}>
      <ShowDetails/>
    </div>
  );
}

export default App;
